import {
  Box,
  Modal,
  Pagination,
  Table,
  TextInput,
  clsx,
  Center,
  Loader
} from '@mantine/core';
import { useEffect, useRef, useState } from 'react';
import notify from '../../../assets/icons/notify.svg';
import { SearchIcon } from '../../../assets/icons/search';
import view from '../../../assets/icons/view.svg';
import Button from '../../../utils/Button/index';
import { paymentDueData } from './properties';
import { useStyles } from './style';
import { useDisclosure } from '@mantine/hooks';
import NotifyPopup from './NotifyPopup';
import { baseURL } from '../../../config/urls';
import { doRedirectIfUnAuth, getHeader } from '../../../config/userSession';
import { Link, useNavigate } from 'react-router-dom';
import { usePlaidLink } from 'react-plaid-link';
import ConfirmAction from './ConfirmAction';
import MonthPickerModal from '../../common/MonthPicker';
import { notifications } from '@mantine/notifications';
import { IconCheck, IconX } from '@tabler/icons-react';
import { noRecordFound } from '../../../utils/const';
import handleSearch from '../../common/Search';
import CustomTooltip from './CustomTooltip';

function ManagerPaymentDue() {
  const [activePage, setActivePage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [entries, setEntries] = useState([]);
  const [pageLoadEntries, setPageLoadEntries] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [isLoading, setLoading] = useState(false);
  const [opened, { close, open }] = useDisclosure(false);
  const [finalToken, setFinalToken] = useState();
  const [accounts, SetAccounts] = useState([]);
  const [isData, setIsData] = useState(false);
  const [linkToken, setLinkToken] = useState(null);
  const [payDetails, setPaydetails] = useState([]);
  const [receiverInfo, setReceiver] = useState('');
  const [payToken, setPayToken] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentAmount, setCurrentAmount] = useState('');
  const [currentElement, setCurrentElement] = useState('');
  const [dueMonth, setDueMonth] = useState('');
  const [dueYear, setDueYear] = useState('');
  const [monthPickerModalOpen, setMonthPickerModalOpen] = useState(false);
  const [dueMonthAndYear, setDueMonthAndYear] = useState('');
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [autoPayEnabled, setAutoPayEnabled] = useState(false);
  const [paymentBreakup, setPaymentBreakup] = useState([]);
  const [autoPayText, setAutoPayText] = useState('');
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');
  const [paymentErrorText, setPaymentErrorText] = useState('');
  const [stripeAccountID, setStripedAccountID] = useState('');
  const { classes, theme } = useStyles(useStyles);

  const cacheListing = useRef({});
  const params = new URLSearchParams();
  params.append('page', activePage);
  params.append('pSize', pageSize);

  const pageChangeHandler = (page) => {
    setActivePage(page);
  };
  async function fetchProfileDetails() {
    setLoading(true);

    const response = await fetch(`${baseURL}/account/profile`, {
      method: 'GET',
      headers: getHeader()
    });

    if (response.ok) {
      let data = await response.json();
      setStripedAccountID(data.user.stripeCustomerId);
      let profileDetails = data.user;
      console.log(profileDetails);

      setLoading(false);
    } else {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchProfileDetails();
  }, []);
  const showNotification = (notificationType, message, title, width) => {
    let colorCode = notificationType === 'success' ? 'secondary.0' : 'red';

    notifications.show({
      id: 'manager-payment-done-notification',
      withCloseButton: true,
      title: title,
      message: message,
      autoClose: false,
      color: colorCode,
      icon:
        notificationType === 'success' ? (
          <IconCheck size="2.5rem" />
        ) : (
          <IconX size="2.5rem" />
        ),
      style: {
        backgroundColor: theme.colors.background[0],
        padding: '12px 12px',
        fontSize: '8rem',
        lineHeight: '1.2',
        minHeight: '120px',
        width: width, // 👈 Set desired width here
        maxWidth: '90%' // Optional: responsive on smaller screens
      },
      styles: {
        title: {
          fontSize: '1.5rem',
          lineHeight: 1.3
        },
        description: {
          fontSize: '1.2rem',
          lineHeight: 1.4
        },
        closeButton: {
          color: 'white',
          backgroundColor: 'black',
          '&:hover': {
            backgroundColor: 'gray', // Change to your preferred hover color
            color: 'yellow' // Example hover text color
          }
        }
      }
    });
  };

  const fetchPaymentDueList = async () => {
    // if (params in cacheListing) {
    //   setEntries(cacheListing[params]);
    //   return;
    // }
    let body = {};
    if (dueMonth && dueYear) {
      body.dueMonth = dueMonth;
      body.dueYear = dueYear;
    }
    if (params.has('page')) {
      body.page = params.get('page');
    }
    if (params.has('pSize')) {
      body.pSize = params.get('pSize');
    }
    const response = await fetch(
      `${baseURL}/property/manager-due-order-list?`,
      {
        method: 'POST',
        headers: getHeader(),
        body: JSON.stringify(body)
      }
    );

    if (response.ok) {
      let responseData = await response.json();
      // console.log('responseData', responseData);
      setEntries(responseData.data);
      setPageLoadEntries(responseData.data);
      setTotalPage((responseData.totalCount + pageSize - 1) / pageSize);
      cacheListing[params] = responseData.data;
    } else {
      doRedirectIfUnAuth(response.status);
    }
    let formattedDate =
      new Date().toLocaleString('default', { month: 'long' }) +
      `, ${new Date().getFullYear()}`;
    if (dueMonth && dueYear) {
      let currentDate = new Date(dueYear, dueMonth - 1, 1);
      formattedDate =
        currentDate.toLocaleString('default', { month: 'long' }) +
        `, ${currentDate.getFullYear()}`;
    }
    setDueMonthAndYear(formattedDate);
  };
  const orderHandler = async (data) => {
    let body = data;
    body.autoPayEnabled = autoPayEnabled;
    body.paymentMethodId = selectedPaymentMethod;
    setModalOpen(false);
    setLoader(true);
    setPaymentErrorText('');
    try {
      const response = await fetch(`${baseURL}/tenant/pay-monthly-rent`, {
        method: 'POST',
        headers: getHeader(),
        body: JSON.stringify(body)
      });
      const data = await response.text();

      if (response.status === 200) {
        setLoader(false);
        let successResponse = JSON.parse(data);
        console.log('successResponse', successResponse);
        showNotification('success', successResponse.msg, '', '450px');
        navigate(`/manager/transaction/${successResponse.transactionId}`);
      } else {
        setLoader(false);
        showNotification(
          'failure',
          data || 'Something went wrong',
          '',
          '450px'
        );
        navigate('/manager/profile');
      }
    } catch (error) {
      setLoader(false);
      console.log('error', error);
    }
  };

  useEffect(() => {
    fetchPaymentDueList();

    fetchPaymentDueList();
  }, [dueMonth, activePage]);
  const loadDuePayment = (data) => {
    setDueMonth(Number(data.selectedDueMonth) + 1);
    setDueYear(data.selectedDueYear);
    setMonthPickerModalOpen(false);
  };
  const handleAutoPayEnabled = (checked) => {
    setAutoPayEnabled(checked);
  };
  console.log(entries);
  const rows = entries?.map((element, index) => (
    <tr
      className={index % 2 === 0 ? classes.tableRowWhite : classes.tableRow}
      key={`${element.firstName}${index}`}
    >
      <td className={classes.tableData}>{element.landlordName}</td>
      <td className={classes.tableData}>{element.propertName}</td>
      <td className={classes.tableData}>${element.totalAmount}</td>

      <td className={classes.tableData}>
        <CustomTooltip
          text={
            element.senderDetails.stripeCustomerId === null
              ? 'Please contact tenant to connect stripe account'
              : 'Click to pay'
          }
          showTooltip={element.senderDetails.stripeCustomerId === null}
        >
          <Button
            onClick={() => {
              setCurrentElement(element);
              setModalOpen(true);
              setCurrentAmount(element.totalAmount);
              setPaymentBreakup([
                { description: 'Rent', amount: element.rentAmount },
                ...element.otherAmounts
              ]);
              setAutoPayEnabled(element.isAutoPayEnabled);
              setAutoPayText(
                element.isAutoPayEnabled
                  ? 'Auto payment has been activated for this rental.'
                  : ''
              );
            }}
            isdisabled={element.senderDetails.stripeCustomerId === null}
            type="submit"
            className={!isLoading ? classes.payBtn : classes.disabledBtnSmall}
            bgColor={theme.colors.primary[0]}
            title="Pay"
          />
        </CustomTooltip>
      </td>
      <td className={classes.tableData}>
        <Box style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Link to={`/manager/rent/${element.orderId}`}>
            <Box className={classes.editAndView}>
              <img className={classes.action} src={view} alt="view" />
            </Box>
          </Link>
        </Box>
      </td>
    </tr>
  ));

  return (
    <Box className={classes.wrapper}>
      {loader ? (
        <Loader
          color="primary.0"
          size="xl"
          variant="bars"
          className={classes.loader}
        />
      ) : (
        ''
      )}
      <Box className={classes.headerAndSearch}>
        <p>
          <span className={classes.title}>Payment</span>
          &nbsp;
          <span className={classes.title}>Due</span>
          <span className={clsx(classes.title, classes.dueTitle)}>
            {' '}
            - {dueMonthAndYear}
          </span>
        </p>
        <Button
          onClick={() => {
            setMonthPickerModalOpen(true);
          }}
          bgColor={theme.colors.primary[0]}
          title={'Change Month'}
        />

        <Box className={classes.searchAndFilter}>
          <TextInput
            icon={<SearchIcon />}
            onChange={(e) =>
              handleSearch(e, pageLoadEntries, setEntries, [
                'landlordName',
                'propertName'
              ])
            }
            radius={'xl'}
            className={classes.searchInput}
            placeholder={paymentDueData.titles.search}
          />
        </Box>
      </Box>
      <Box className={classes.tableContainer}>
        <Table className={classes.table}>
          <thead className={classes.tableHead}>
            <tr>
              {paymentDueData.tableHeading.map((heading) => {
                return <th className={classes.columnHeading}>{heading}</th>;
              })}
            </tr>
          </thead>
          <tbody>{entries.length > 0 ? rows : <></>} </tbody>
        </Table>
        <div>
          {entries.length > 0 ? (
            <></>
          ) : (
            <div className={classes.noRecordTableRow}>
              {' '}
              <div className={classes.noRecordtitle}>
                Great news! There is no payment due at the moment.
              </div>{' '}
            </div>
          )}
        </div>
      </Box>

      <NotifyPopup opened={opened} close={close} />
      {rows.length === 0 ? (
        <p className="no-record-found"> {noRecordFound} </p>
      ) : (
        <Pagination
          size={'md'}
          defaultValue={activePage}
          onChange={pageChangeHandler}
          className={classes.pagination}
          siblings={1}
          total={totalPage}
        />
      )}
      <ConfirmAction
        paymentBreakup={paymentBreakup}
        currentAmount={currentAmount}
        currentElement={currentElement}
        modalOpen={modalOpen}
        autoPayEnabled={autoPayEnabled}
        setAutoPayEnabled={handleAutoPayEnabled}
        autoPayText={autoPayText}
        selectedPaymentMethod={selectedPaymentMethod}
        setSelectedPaymentMethod={setSelectedPaymentMethod}
        paymentErrorText={paymentErrorText}
        onClose={() => setModalOpen(false)}
        onYes={orderHandler}
      />
      <MonthPickerModal
        modalOpen={monthPickerModalOpen}
        onClose={() => setMonthPickerModalOpen(false)}
        onYes={loadDuePayment}
      />
    </Box>
  );
}

export default ManagerPaymentDue;
